import * as React from 'react';
import { Tooltip } from 'react-tooltip';
export const Wrapper = ({ badge, layout, children, }) => {
    if (!layout || layout === 'icon-only') {
        return (React.createElement("div", { className: "members-badges-lib-style-wrapper" },
            children,
            React.createElement(Tooltip, { className: "react-tooltip", id: badge.id, place: "top", offset: 12, positionStrategy: "fixed", opacity: 1 })));
    }
    return React.createElement("div", { className: "members-badges-lib-style-wrapper" }, children);
};
//# sourceMappingURL=Wrapper.js.map